import { AIFeatureType } from "../../enums/CompassAI";
import { MESSAGES } from "../../messages";

// Icons
import fileIcon from "../../assets/svg/file_icon.svg";
import linkIcon from "../../assets/svg/link.svg";
import voteIcon from "../../assets/svg/voting_black.svg";
import engagementIcon from "../../assets/svg/engagement.svg";

// Background images
import engagementExtractionBg from "../../assets/images/engagement_record_generation.png";
import engagementLinkageBg from "../../assets/images/engagement_vote_linkage.png";
import votingAlignmentBg from "../../assets/images/voting_alignment.png";
import engagementRatingBg from "../../assets/images/engagement_rating.png";

export interface AIFeatureItem {
  type: AIFeatureType;
  title: string;
  description: string;
  icon: string;
  bg?: string;
  isActive: boolean;
}

const messages = MESSAGES.COMPASS_AI;

export const AI_FEATURE_ITEMS: AIFeatureItem[] = [
  {
    type: AIFeatureType.PDF_EXTRACTION,
    title: "Engagement Extraction",
    description:
      "Upload PDFs or Word documents to generate structured engagement records.",
    icon: fileIcon,
    bg: engagementExtractionBg,
    isActive: true,
  },
  {
    type: AIFeatureType.SINGLE_LINKAGE,
    title: messages.LINKAGE_ANALYSIS.MODAL_TITLE,
    description: messages.LINKAGE_ANALYSIS.DESCRIPTION.IDLE,
    icon: linkIcon,
    bg: engagementLinkageBg,
    isActive: true,
  },
  {
    type: AIFeatureType.VOTING_ALIGNMENT,
    title: "Voting Alignment",
    description:
      "Upload a policy document to compare alignment between your policy and manager votes.",
    icon: voteIcon,
    bg: votingAlignmentBg,
    isActive: false,
  },
  {
    type: AIFeatureType.ENGAGEMENT_RATING,
    title: "Engagement Rating",
    description:
      "Augment your engagement records with detailed qualitative metrics.",
    icon: engagementIcon,
    bg: engagementRatingBg,
    isActive: true,
  },
];
